<template><div><h1 id="gutscheine-aufbereiten" tabindex="-1"><a class="header-anchor" href="#gutscheine-aufbereiten"><span>Gutscheine aufbereiten</span></a></h1>
<p>Gutscheine aufbereiten — Aufbereitung der erfassten Gutscheine</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Aufbereitungsjob für die Produktion der Gutschein-Fakturen.</p>
<p>Pfad: <code v-pre>Verkauf → Verarbeitungsläufe → Fakturen/Avis verarbeiten → Gutscheine aufbereiten</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Jobdatum/laufnummer</dt>
<dd>Jobdatum und Laufnummer pro Datum</dd>
<dt>maximale Anzahl</dt>
<dd>Einschränkung auf maximale Anzahl Fakturen, die aufbereitet werden sollen</dd>
<dt>bis Datum</dt>
<dd>Einschränkung nach Verarbeitungsdatum im Auftragskopf (Standard: Erfassungsdatum)</dd>
<dt>Jobgruppe</dt>
<dd>Anzeige der Jobgruppe, zu welcher der Job gehört. Diese wird vom System vergeben, um verschiedene WBS-Aufbereitungsläufe in einer Bereitstellungsliste zusammenfassen zu können und um diese entsprechend auch gemeinsam drucken zu können</dd>
<dt>Aufbereitete WBS</dt>
<dd>Anzeige der Anzahl der Fakturen (Rechnungen, Lieferscheine, Geschenkbons, Avisierungen etc.), welche im jeweiligen Job bearbeitet wurden</dd>
<dt>Anzahl Durchgänge</dt>
<dd>Anzeige der Anzahl Durchgänge, welche der Job für die Aufbereitung der Daten benötigt hat</dd>
<dt>von/bis Fakturanummer</dt>
<dd>Anzeige der niedrigsten / höchsten Fakturanummer, die im Job verarbeitet wurde</dd>
<dt>Versandart</dt>
<dd>Angabe von bis zu neun Verarbeitungsarten aus Tabelle <a class="link" href="ft.refdata.tblverarb.html" title="Verarbeitungsarten">Verarbeitungsarten</a></dd>
<dt>Auftragsart</dt>
<dd>Einschränkung auf 1 <a class="link" href="ft.refdata.tblaufart.html" title="Auftragsart">Auftragsart</a>, die aufbereitet werden soll.</dd>
<dt>Geduldstufe</dt>
<dd>Avisierung von Aufträgen, die schon die letzte <a class="link" href="ft.refdata.tblgeduld.html" title="Geduldstufen">Geduldstufe</a> erreicht haben oder nur Aufträge, die im aktuellen Lauf die Geduldstufe ändern.</dd>
<dt>nur von Auftraggeber</dt>
<dd>Einschränkung auf einen einzigen Auftarggeber.</dd>
<dt>mit Merkmal</dt>
<dd>Einschränkung auf Auftarggeber mit bestimmtem Merkmal</dd>
<dt>mit Artikel</dt>
<dd>Einschränkung auf Aufträge, die diesen Artikel beinhalten</dd>
<dt>Positionen aufbereiten</dt>
<dd>Festlegung ob in Aufträgen, in denen dieser Artikel enthalten ist, nur dieser Artikel aufbereitet werden soll, oder alle Auftragspositionen des Auftrags.</dd>
<dt>LS-Druckdatum</dt>
<dd>Druckdatum des Direktlieferanten-Lieferscheins; wird vom System automatisch vergeben</dd>
<dt>LS-Druckdatei</dt>
<dd>Druckdatei des Direktlieferanten-Lieferscheins</dd>
<dt>LS-Drucker</dt>
<dd>Drucker für Direktlieferanten-Lieferscheine</dd>
<dt>Druckdatum</dt>
<dd>Anzeige des Datums, an dem der Job gedruckt wurde.</dd>
<dt>Druckdatei</dt>
<dd>Anzeige der für den Output gewählten Druckdatei (optional)</dd>
<dt>Druckername</dt>
<dd>Name des Druckers, auf den der Job ausgegeben werden soll. Bei der Angabe einer Druckdatei werden die für den angegebenen Drucker gültigen Initialisierungssteuerzeichen in die Datei geschrieben</dd>
<dt>Verarbeitungsstatus</dt>
<dd>Status des Aufbereitungsjobs:
<table>
<thead>
<tr>
<th>Status</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>1</td>
<td>Job-Parameter erfasst; noch nicht aufbereitet; löschbar</td>
</tr>
<tr>
<td>2</td>
<td>Aufbereitung angefangen (bzw. abgebrochen)</td>
</tr>
<tr>
<td>3</td>
<td>Aufbereitung erfolgreich abgeschlossen; noch nicht gedruckt</td>
</tr>
<tr>
<td>5</td>
<td>Avis aufbereitet und gedruckt</td>
</tr>
<tr>
<td>6</td>
<td>WBS und DLS aufbereitet; WBS gedruckt</td>
</tr>
<tr>
<td>7</td>
<td>Geschenkbons aufbereitet und gedruckt</td>
</tr>
<tr>
<td>8</td>
<td>WBS und DLS aufbereitet; DLS gedruckt</td>
</tr>
<tr>
<td>9</td>
<td>WBS und DLS aufbereitet; WBS und DLS gedruckt</td>
</tr>
<tr>
<td>X</td>
<td>Job erledigt; keine ausstehenden WBS / GB / Avis gefunden</td>
</tr>
</tbody>
</table>
</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="aufbereiten" tabindex="-1"><a class="header-anchor" href="#aufbereiten"><span>Aufbereiten</span></a></h3>
<p>Startet die Aufbereitung und druckt das Protokoll nach der Eingabe von Job- und Laufnummer (Bereich).</p>
<h3 id="fakturen-drucken" tabindex="-1"><a class="header-anchor" href="#fakturen-drucken"><span>Fakturen drucken</span></a></h3>
<p>Ermöglicht die Ausgabe der aufbereiteten Rechnungen auf einen Drucker oder in eine Druckdatei.</p>
<h3 id="kopien-drucken" tabindex="-1"><a class="header-anchor" href="#kopien-drucken"><span>Kopien drucken</span></a></h3>
<p>Druckt Kopien von aufbereiteten und gedruckten GB-Fakturen (siehe oben).</p>
<h3 id="fakturen-zurucksetzen" tabindex="-1"><a class="header-anchor" href="#fakturen-zurucksetzen"><span>Fakturen zurücksetzen</span></a></h3>
<p>Die Fakturen mit der eingetragenen Fakturanummer werden rückgängig gemacht und sind deshalb auch wieder löschbar. Es können auch weitere Gutscheine hinzugefügt werden. Die Gutscheine sind wieder pendent. Beim nächsten Aufbereitungslauf wird also eine neue Geschenkbon-Faktura gedruckt.</p>
<div class="hint-container warning">
<p class="hint-container-title">Achtung</p>
<p>Bereits gedruckte Fakturen dürfen nur rückgängig gemacht werden, wenn sie noch nicht an den Kunden verschickt worden sind!</p>
</div>
<h3 id="protokoll-drucken" tabindex="-1"><a class="header-anchor" href="#protokoll-drucken"><span>Protokoll drucken</span></a></h3>
<p>Druckt die Aufbereitungsprotokolle nach Jobdatum (von/bis).</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


